import React, { Component, Fragment } from 'react'
import { css } from 'aphrodite';
import { SEStyles } from '../../common/components/SubEntity/SEStyles';

import { CustomSEStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { AppButton } from '../../common/components/AppButton';

export class SubEntityCustomListCard extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.heading)}>
          <div className={css(Styles.headingContent)}>
            <h2 className={css(Styles.stepFormTitle)}>{this.props.title}</h2>
            {!this.props.noEdit &&
              <AppButton
                onClick={() => this.props.openModalForEdit(this.props.item)}
                buttonText={'Edit'}
                buttonStyle={Styles.editButton}
                buttonTextStyle={Styles.buttonText} />
            }
          </div>
        </div>
        <div className={this.props.renderFieldsRowwise ? css([Styles.content, Styles.contentForRow]) : css(Styles.content)}>
          {this.props.mainFields  && this.generateContent(this.props.mainFields)}
        </div>
      </div>
    )
  }

  generateContent(fields) {
    return (<Fragment>
      {fields.map((item, index) => {
        return (
          <Fragment>
            <div key={item.label} className={this.props.renderFieldsRowwise ? css([Styles.labelContainer, Styles.labelContainerForRow]) : css(Styles.labelContainer)}>
              {this.labelDisplay(item.label)}
              {this.valueDisplay(item.value)}
            </div>
            {this.props.renderFieldsRowwise && index % 2 === 0 && <div className={css(Styles.dividerForRow)} />}
          </Fragment>
        )
      })}
    </Fragment>)
  }

  labelDisplay(label) {
    return (<div className={css(Styles.fieldActionsContainer)}>
      <p className={css(Styles.label)}>{label}</p>
    </div>)
  }

  valueDisplay(value) {
    const valueDisplayStyle = [Styles.value]
    return <div className={css(Styles.valueContainer)}>
      {value}
    </div>

  }

}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('SubEntityCard')) ? CustomSEStyles : SEStyles



// WEBPACK FOOTER //
// ./src/screens/admin/SubEntityCustomListCard.js